import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { fetchEventPosts, type BlogPost } from "../services/bloggerApi";
import BlogPostComponent from "./BlogPost";
import { Link } from "react-router-dom";

const EventsPreview = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadPosts = async () => {
      try {
        setLoading(true);
        const data = await fetchEventPosts();
        setPosts(data.items.slice(0, 4));
      } catch (err) {
        setError(
          "Etkinlikler yüklenirken bir hata oluştu. Lütfen tekrar deneyin.",
        );
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, []);

  return (
    <section className="py-32 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 tracking-wide">
            Etkinliklerimiz
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto">
            Kolektif Oluşum olarak düzenlediğimiz etkinliklerle öğrencileri bir
            araya getiriyor, network oluşturuyor ve gelişimlerine katkıda
            bulunuyoruz.
          </p>
        </motion.div>

        {error ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center text-red-400 p-6 rounded-xl bg-red-900/50 backdrop-blur-sm border border-red-500/20"
          >
            {error}
          </motion.div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {posts.map((post, index) => (
                <motion.div
                  key={post.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <BlogPostComponent post={post} variant="event" />
                </motion.div>
              ))}
            </div>

            {loading && (
              <div className="flex justify-center mt-8">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-400"></div>
              </div>
            )}

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ delay: 0.4 }}
              className="text-center mt-16"
            >
              <Link
                to="/etkinliklerimiz"
                className="inline-flex items-center px-8 py-4 text-lg rounded-2xl text-white bg-blue-600 hover:bg-blue-700 transform hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-blue-500/25"
              >
                Tüm Etkinlikleri Gör
                <svg
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-200"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </motion.div>
          </>
        )}
      </div>
    </section>
  );
};

export default EventsPreview;
